<template>
  
  <div>
       <transition name="fade" appear>
            <div class="h-full w-full flex justify-center items-center">

                <div class="modal-overlay flex flex-col justify-center 
                rounded lg:rounded p-1 lg:p-5 border-pink-500 border-4 lg:border-8
                bg-blue-600 lg:h-1/2 lg:w-1/2" v-if="showModal">
                
                    <div class="w-full flex justify-center">
                        <button
                        class="mr-2 lg:mr-5 px-1 lg:px-4 py-2 bg-red-500 shadow-lg border rounded-lg text-white w-24 lg:w-48    
                        uppercase font-semibold tracking-wider focus:outline-none focus:shadow-outline hover:bg-red-400 active:bg-red-400"
                        @click="closeModal" > <label >{{$t('profile.close')}}</label> </button>
                    
                    </div>
                    
                    <div class="flex flex-row justify-between items-center">

                        <div v-if="modalImages.length > 1" @click="nextOrPrevious(false)"
                            class="w-32 h-16 flex justify-center items-center rounded-lg lg:rounded-full bg-pink-500 hover:bg-pink-400">

                            <!-- <a href="#" class="previous round">&#8249;</a> -->
                            <div class="w-8 lg:w-16 text-white">
                                <label ><strong>&#8249;</strong></label>
                            </div>
                        </div>
                       
                            <div class="mx-2 lg:mx-5 mt-1 lg:mt-4 ">

                                <img :src="modalImages[index].image" />
                            </div>

                        <div v-if="modalImages.length > 1" @click="nextOrPrevious(true)"
                            class="w-32 h-16 flex justify-center items-center rounded-lg lg:rounded-full bg-pink-500 hover:bg-pink-400">
                            
                            <div class="w-8 lg:w-16 text-white">
                                <label><strong>&#8250;</strong></label>
                            </div>
                        </div>
                    </div>

                    <div 
                    class="flex flex-col items-center justify-center bg-pink-400 text-white w-full rounded-lg mt-5 lg:mt-10">
                        
                        <div>

                            <label class="text-black"> {{$t('business.business')}} <strong class="text-white">{{modalImages[index].business}}</strong></label>
                        </div>

                        <div>

                            <label class="text-black "> {{$t('classes.class')}} <strong class="text-white">{{modalImages[index].class}}</strong></label>                            
                        </div>

                        <div>

                            <label class=" "> {{$t('sessions.imageNumber')}}<strong class="text-white">{{index+1}} of {{modalImages.length}}</strong></label> 
                        </div>
                    </div>
                </div>
            </div>
        </transition>
  </div>
</template>

<script>
export default {

    mounted(){

        // console.log(`in image viewer`);
        // this.inModalImages = this.modalImages;

        this.displayingImage = this.modalImages[0];
    },

    props:{

        changeShowModal:{

            type: Function
        },

        modalImages: {

            type: Array 
        },

        showModal: false,
    },

    methods:{

        closeModal(){

            this.index = 0;

            this.changeShowModal(false);
        },

        nextOrPrevious(val){

            if(val){

                if(this.index != this.modalImages.length - 1)
                {
                    this.index = this.index + 1;
                }
                else{
                    
                    this.index = 0;
                }
            }
            else{
                
                if(this.index != 0){

                    this.index = this.index - 1;
                }
                else{

                    this.index = this.modalImages.length - 1;
                }
            }

            this.displayingImage = this.modalImages[this.index];


            // console.log(`modalImages.length is: ${this.modalImages.length}`);

            // console.log(`index is: ${this.index}`);

            // console.log(`this.displayingImage is: ${JSON.stringify(this.displayingImage)}`);

        },

    },

    data: function(){

        return{

            displayingImage: '',
            
            // inModalImages: [],

            index: 0,
        }
    }
}
</script>

<style>


    /* a {
    text-decoration: none;
    display: inline-block;
    padding: 8px 16px;
    }

    a:hover {
    background-color: #fbb6ce;
    color: white;
    }

    .previous {
    background-color: #ed64a6;
    color: white;
    }

    .next {
    background-color: #ed64a6;
    color: white;
    }

    .round {
    border-radius: 50%;
    } */

@media screen and (max-width: 768px) {

    .modal-overlay {

        position: absolute;

        top: 25%;

    }
}

@media screen and (min-width: 768px) {

    .modal-overlay {

        position: absolute;

/* transform: translate(50%, 50%); */

        top: 25%;
        left: 25%;
    }

}
</style>